import { Icon } from '@apia/icons';
import { TIconRenderer } from '../types';
import { Box, Image } from '@apia/theme';
import { memo } from 'react';

const DefaultIconRendererNoMemo: TIconRenderer = (props) => {
  if (!props.icon && !props.imageUrl) {
    console.error({ props });
    console.error('The icon has no imageUrl nor icon defined');
  }

  return (
    <Box
      title={String(props.ariaLabel) || props.label}
      className="iconsList__icon__wrapper"
    >
      <Box className="iconsList__icon__image__wrapper">
        {props.imageUrl && (
          <Image
            className="iconsList__icon__image"
            src={props.imageUrl}
            role="none"
            alt=""
          />
        )}
        {props.icon && <Icon icon={props.icon} title={props.ariaLabel} />}
      </Box>
      <Box className="iconsList__icon__label" title={props.ariaLabel}>
        {props.label}
      </Box>
    </Box>
  );
};

export const DefaultIconRenderer = memo(DefaultIconRendererNoMemo);
